<template>
  <div id="changePassWord">
    <div class="contentBox">
      <div class="leftImg">
        <div style="position: absolute;left: 80px;top: 50px">
          <img src="../assets/img/logo.png" alt="">
          <span style="font-size: 20px;color: #FFFFFF;vertical-align: middle">通用仿真软件</span>
        </div>
        <img src="../../static/img/userLeft.png" alt="" style="width: 100%;height: 100%">
      </div>

      <div class="rightContent">
       <span class="returnIndex" style="cursor: pointer" title="返回主页"  @click="$router.push('/')">
          <Icon type="md-home" size="20"/>
        </span>
        <div style="text-align: center">
          <div class="title" style="margin-top: 160px;">修改密码</div>
        </div>
        <div style="margin-bottom: 20px;margin-top: 50px">
          <div>账号</div>
          <Input v-model="resetData.username" style="width: 360px;margin-top: 8px" placeholder="请输入您的账号"/>
        </div>
        <div style="margin-bottom: 20px;">
          <div>原密码</div>
          <Input v-model="resetData.oldpsd" :type="inputType" style="width: 360px;margin-top: 8px" placeholder="请输入您的密码"/>
          <span @click="changeInputType" style="position: relative;right: 25px;cursor: pointer;top: 3px">
              <img v-if="inputType==='password'" src="../assets/img/eye.png" alt="">
              <img v-if="inputType==='text'" src="../assets/img/hideeye.png" alt="">
          </span>
        </div>
        <div style="margin-bottom: 20px;">
          <div>新密码</div>
          <Input v-model="resetData.newpsd" @blur="psdCheck" :type="inputType" style="width: 360px;margin-top: 8px" placeholder="密码格式为8-16位大小写字母和数字组合"/>
          <span @click="changeInputType" style="position: relative;right: 25px;cursor: pointer;top: 3px">
              <img v-if="inputType==='password'" src="../assets/img/eye.png" alt="">
              <img v-if="inputType==='text'" src="../assets/img/hideeye.png" alt="">
          </span>
        </div>
        <div style="margin-bottom: 20px;">
          <div>确认密码</div>
          <Input v-model="resetData.twicepsd" @blur="twicepsdCheck" :type="inputType" style="width: 360px;margin-top: 8px" placeholder="请再次输入您的密码"/>
          <span @click="changeInputType" style="position: relative;right: 25px;cursor: pointer;top: 3px">
              <img v-if="inputType==='password'" src="../assets/img/eye.png" alt="">
              <img v-if="inputType==='text'" src="../assets/img/hideeye.png" alt="">
          </span>
        </div>
        <div style="margin-bottom: 20px;">
          <div>验证码</div>
          <Input v-model="resetData.captcha" style="width: 170px;margin-top: 8px"/>
          <img @click="changeCap" :src=captchaURL alt="" class="yzm"
               style="width: 170px;border-radius: 4px;border: 1px solid #DCDFE6;height: 40px;margin-left: 20px;margin-top: 8px">
        </div>
        <div>
          <div  @click="passWordChanged" style="width: 360px;height: 40px;background:  #0069E0;border-radius: 4px;
            line-height: 40px;text-align: center;color: white;cursor: pointer;font-size: 18px">
            修改密码
          </div>
          <div  @click="jump('index')" style="width: 360px;height: 40px;border: 1px solid #0069E0;;border-radius: 4px;
            line-height: 40px;text-align: center;color:#0069E0;margin-top: 16px;cursor: pointer;font-size: 18px">
            返回
          </div>
        </div>





      </div>
    </div>

  </div>

</template>

<script>
  import {username, smsCode, reset, captcha} from '../api/index'

  export default {
    name: "changePassWord",
    data() {
      return {
        // 接口地址修改
        captchaURL: captcha + "?_=" + Math.floor(Math.random() * 100),
        ifForget: false,
        resetData: {
          username:'',
          captcha: '',
          oldpsd: '',
          newpsd: '',
          twicepsd: '',

          ispsdtrue: false,
          istwicepsdtrue: false
        },
        inputType: 'password',
      }
    },
    methods: {
      changeInputType() {
        if (this.inputType === 'text') {
          this.inputType = 'password'
        } else {
          this.inputType = 'text'
        }

      },
      changeCap() {
        // 接口地址修改
        this.captchaURL = captcha + "?_" + Math.floor(Math.random() * 100)
      },

      // login() {
      //   username(this.loginData).then((res) => {
      //     let resData = res.data
      //     console.log(resData)
      //     if (resData.result.success == false) {
      //       this.changeCap();
      //       this.$Message.error(resData.result.info);
      //     }
      //     if (resData.result.success == true) {
      //
      //       this.$cookies.set("userId", resData.result.data.user.id,'3d')
      //       this.$cookies.set("userName", resData.result.data.user.username,'3d')
      //       this.$cookies.set("nickName", resData.result.data.user.nickname,'3d')
      //       this.$cookies.set("auth", resData.result.data.auth,'3d')
      //       this.$router.push('/')
      //
      //       // 地址修改
      //       // window.location.href = "http://localhost:8081/#/cloudDisk";
      //       // window.location.href='/sep/#/cloudDisk'
      //
      //
      //     }
      //   }).catch((error) => {
      //     console.log(error);
      //   });
      //
      //
      // },




      psdCheck() {
        let reg = /(?!.*\s)(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/;
        if (reg.test(this.resetData.newpsd) == false) {
          this.$Message.error('密码格式错误');
          this.resetData.ispsdtrue = false
        } else {
          this.resetData.ispsdtrue = true
        }
      },

      twicepsdCheck() {
        if (this.resetData.newpsd != this.resetData.twicepsd) {
          this.$Message.error('两次输入密码不符');
          this.resetData.istwicepsdtrue = false
        } else {
          this.resetData.istwicepsdtrue = true
        }
      },

      passWordChanged() {
        if (this.resetData.ispsdtrue == false) {
          this.$Message.error('密码格式错误');
        }
        if (this.resetData.ispsdtrue == true && this.resetData.istwicepsdtrue == false) {
          this.$Message.error('两次输入密码不符');
        }
        if (this.resetData.ispsdtrue == true && this.resetData.istwicepsdtrue == true) {
          let obj = {
            username:this.resetData.username,
            captcha:this.resetData.captcha,
            oldPassword:this.resetData.oldpsd,
            password: this.resetData.newpsd
          }
          reset(obj).then((res) => {
            let resData = res.data
            if (resData.result.success == false) {
              this.$Message.error(resData.result.info);
            }
            if (resData.result.success == true) {
              this.$Message.success(resData.result.info);
              this.jump('login')
            }
          }).catch((error) => {
            console.log(error);
          })
        }
      },

      jump(target) {
        this.$router.push(target)
      },
      keyDown(e){
        //如果是回车则执行登录方法
        if(e.keyCode == 13){
          this.login();
        }
      },



    },

    mounted() {
      window.addEventListener('keydown',this.keyDown);



    },
    destroyed(){
      window.removeEventListener('keydown',this.keyDown,false);
    }

  }
</script>

<style scoped lang="scss">
  #changePassWord {
    background-color: #4871E1;
    overflow: hidden;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }

  .contentBox {
    display: flex;
    width: 100%;
    height: 100%;
    background: #FFFFFF;


    .leftImg{
      width: 57%;
      display: inline-block;
    }
    .rightContent{
      display: flex;
      width: 43%;
      justify-content: flex-start;
      flex-wrap: wrap;
      flex-direction: column;
      align-content: center;
      .title{
        width: 100%;
        font-weight: 500;
        text-align: center;
        font-size: 30px;
        color: #333333;

      }
      .inputBox{
        display: inline-block;
        background: #FFFFFF;
        border: 1px solid #DCDCDC;
        border-radius: 25px;
        width: 340px;
        height: 50px;
        margin-bottom: 20px;
        padding: 15px 30px;
        text-align: left;
        .icons{
          width: 22px;
        }
        .inputkuang{
          margin-left: 15px;
          height: 20px;
          width: 235px;
          border: none;
          outline: none;
          &:focus{
            border: none;
          }
        }
        .yzm{
          float: right;
          top: -7px;
          right: -13px;
          position: relative;
          width: 80px;
          height: 30px;
        }
      }
      .forgetPwd{
        display: inline-block;
        font-size: 14px;
        color: #666666;
        width: 340px;
        padding: 0 20px;
        text-align: right;
      }
      .getMes{
        cursor: pointer;
        font-size: 14px;
        color: #2651BB;
        text-align: right;
        display: inline-block;
        width: 56px;
        height: 20px;
      }
      .buttons{
        margin-top: 15px;
        display: inline-block;
        width: 340px;
        .buttonR {
          cursor: pointer;
          display: inline-block;
          background: #E5E7ED;
          border-radius: 25px;
          width: 160px;
          height: 50px;
          font-size: 16px;
          color: #5E677D;
          text-align: center;
          padding: 15px;
          float: left;
        }
        .buttonL {
          cursor: pointer;
          display: inline-block;
          background: #2651BB;
          border-radius: 25px;
          width: 160px;
          height: 50px;
          font-size: 16px;
          color: #FFFFFF;
          text-align: center;
          padding: 15px;
          float: right;
        }
      }
      .tips{
        margin-bottom: 10px;
        padding-left: 30px;
        width: 340px;
        display: inline-block;
        text-align: left;
        font-size: 14px;
        color: #666666;
      }
    }
  }
  .returnIndex{
    position: absolute;
    display: inline-block;
    right: 15px;
    float: right;
    top: 15px;
  }

  /*.loginBox {*/
  /*  border: 3px white solid;*/
  /*  margin-top: 12%;*/
  /*  text-align: center;*/
  /*  padding: 50px 0;*/
  /*  background: rgba(255, 255, 255, .6);*/

  /*  .backindex {*/
  /*    position: absolute;*/
  /*    right: 15px;*/
  /*    top: 15px;*/
  /*    font-size: 16px;*/
  /*    color: black;*/
  /*    cursor: pointer;*/
  /*  }*/

  /*  .title {*/
  /*    margin-bottom: 40px;*/
  /*    color: black;*/
  /*  }*/

  /*  .inputLabel {*/
  /*    color: black;*/
  /*    font-size: 16px;*/
  /*    padding-top: 5px;*/
  /*  }*/

  /*  .inputBox {*/
  /*    background: none;*/
  /*    border: white 2px solid !important;*/
  /*  }*/

  /*  .yzmimg {*/
  /*    img {*/
  /*      width: 100%;*/
  /*      height: 32px;*/
  /*    }*/

  /*  }*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/changePassWord.vue